var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enableStickyHeight)?_c('sticky-viewport-filler-height',{ref:"root",attrs:{"min-height":_vm.minHeight,"sticky-top-offset":_vm.stickyTopOffset,"sticky-bottom-offset":_vm.stickyBottomOffset}},[_vm._t("default")],2):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }